<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
    <div>
      <a-form class="flex-form" :form="modal.form" :colon="false">
        <a-input style="display:none" v-decorator="['infoCountryId']"></a-input>
        <a-form-item label="前往国家" required :labelCol="{ style: 'width:90px' }">
          <a-select
            v-decorator="[
              'infoCountryId',
              {
                rules: [{ required: true, message: '请选择前往国家' }],
              },
            ]"
            :disabled="edit"
            placeholder="请选择"
            :options="countryList"
            style="width: 100%"
            allowClear
            showSearch
            @change="getCountryCode"
            :filterOption="filterByPY$t"
          ></a-select>
        </a-form-item>
        <a-form-item v-if="SingleOrDouble === 3" label="国家编码" required :labelCol="{ style: 'width:90px' }">
          <a-input-number
            v-decorator="[
              'correspondingNum',
              {
                rules: [{ required: true, message: '请输入国家编码' }],
              },
            ]"
            disabled
            placeholder="请输入国家编码"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="民事价格" required :labelCol="{ style: 'width:90px' }">
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['infoCivilPrice']"
            placeholder="请输入价格"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="商业价格" required :labelCol="{ style: 'width:90px' }">
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['infoBusinessPrice']"
            placeholder="请输入价格"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="普通时长" required :labelCol="{ style: 'width:90px' }">
          <a-input
            v-decorator="[
              'infoOrdinaryDuration',
              {
                rules: [{ required: true, message: '普通时长不能为空' }],
              },
            ]"
            placeholder="请输入普通时长，如：普通（10-15个工作日）"
          ></a-input>
        </a-form-item>
        <a-form-item label="加急时长" required :labelCol="{ style: 'width:90px' }">
          <a-input
            v-decorator="[
              'infoUrgentDuration',
              {
                rules: [{ required: true, message: '加急时长不能为空' }],
              },
            ]"
            placeholder="请输入加急时长，如：加急（6-8个工作日）"
          ></a-input>
        </a-form-item>
        <a-form-item label="有关规定" required :labelCol="{ style: 'width:90px' }">
          <a-textarea v-decorator="['infoDescription']" placeholder="请输入有关规定" showCount></a-textarea>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    return {
      edit: false,
      countryList: [],
      SingleOrDouble: null,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '配置国家及信息',
        data: {},
      },
    }
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    getCountryCode(e) {
      console.log('选择国家change', e)
      console.log('this.countryList', JSON.stringify(this.countryList))
      const countryCode = this.countryList.find(v => v.value == e)
      console.log('countryCode', countryCode)
      if (countryCode) {
        this.modal.form.setFieldsValue({
          correspondingNum: countryCode.countryCode,
        })
      }
    },
    async getCountryList(type, index) {
      if (index == 3) {
        this.$axios
          .get('/additional/admin/dictionary/queryByParentKey?parentKey=renzhenghaiyaguojiaguanli')
          .then(res => {
            this.countryList = res.data.map(item => {
              return {
                label: item.dictionaryName,
                value: item.dictionaryId,
                countryCode: item.dictionaryValue,
              }
            })
            if (type === 1) {
              this.countryList.unshift({
                value: 0,
                label: '全部',
              })
            }
          })
      } else {
        this.$axios.get('/additional/admin/dictionary/queryByParentKey?parentKey=renzhengguojiaguanli').then(res => {
          this.countryList = res.data.map(item => {
            return {
              label: item.dictionaryName,
              value: item.dictionaryId,
            }
          })
          if (type === 1) {
            this.countryList.unshift({
              value: 0,
              label: '全部',
            })
          }
        })
      }
    },
    async start(row, type, SingleOrDouble) {
      if (SingleOrDouble) {
        this.SingleOrDouble = SingleOrDouble
      }
      this.resetModal$t()
      if (type === 'add') {
        this.getCountryList(2, SingleOrDouble)
        this.edit = false
      } else {
        this.getCountryList(1, SingleOrDouble)
        this.edit = true
      }
      this.modal.visible = true
      this.modal.data = {
        ...row,
      }
      if (row) {
        this.safeSetFieldsValue$t(this.modal.form, { ...row })
      }
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            resolve()
            // reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          if (this.SingleOrDouble) {
            params.infoType = this.SingleOrDouble
          }
          if (params.infoCountryId !== 0) {
            const find = this.countryList.find(v => v.value === params.infoCountryId).label
            console.log(find)
            params['infoCountryName'] = find
          }
          try {
            // this.$message.success('操作成功!')
            this.modal.visible = false
            this.$emit('end', 'ok', params)
          } catch (e) {}
        }
      })
    },
    handleCancel() {
      this.modal.visible = false
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
